import React, { useState, useEffect, useRef } from "react";
import {
  Avatar,
  Box,
  Button,
  getColor,
  Icons,
  InfiniteScrollBox,
  Modal,
  Tabs,
  Tooltip,
  Tree,
  Typography,
} from "fds";
import "./index.scss";
import classNames from "classnames";
import utilsCommon from "../../shared/utils/common";
import { TreeNode } from "fds/src/components/atom/Tree";
import { getUserInfoFromLocalStorage } from "../../shared/utils/auth";
import { LoginDto } from "../../types/auth";
import useWorkgroupStore from "../../redux/dispatcher/useWorkgroupStore";
import { Member } from "../../types/workgroup";
import { t } from "i18next";
import { Trans } from "react-i18next";
import i18n from "../../locales/i18n";
interface SelectUserModalProps {
  open: boolean;
  onClose: () => void;
  onClick: (users: any) => void;
  isClient?: boolean;
  addedUserList?: any[];
  disableValues?: string[];
  classes?: string;
}
const SelectUserModal: React.FC<SelectUserModalProps> = ({
  open,
  onClose,
  onClick,
  isClient,
  addedUserList,
  disableValues,
  classes,
}) => {
  const workgroupListNewCard = useRef([] as any[]);
  const user = getUserInfoFromLocalStorage() as string | "";
  const loginDto: LoginDto = JSON.parse(user);
  const myId = loginDto?.userInfo?.userId ?? "";
  const { workgroupState, getMemberList, getOrgansTree } = useWorkgroupStore();
  const [tab, changeTab] = useState(0);
  const [treeData, changeTreeData] = useState<TreeNode[]>();
  const [key, setKey] = useState(0);
  const [expandValues, setExpandValues] = useState([
    "ae4fc0f5fd8f4142834c1ad4e929a514",
  ] as string[]);
  const [checkValues, changeCheckValues] = useState<any[]>(addedUserList ?? []);
  useEffect(() => {
    getOrgansTree({
      version: "1.0",
      path: "ae4fc0f5fd8f4142834c1ad4e929a514",
      root: "N",
      onlyDept: "N",
    });
    getMemberList({
      externalPos: 1,
      tenancyCode: "",
      type: "external",
    });
  }, []);
  useEffect(() => {
    changeTreeData(workgroupState.treeData?.nodes);
  }, [workgroupState.treeData]);
  useEffect(() => {
    let newDataCardContent = [] as any[];
    workgroupState.externalUserList?.forEach((item: Member) => {
      newDataCardContent.push(renderExternalUser(item));
    });
    workgroupListNewCard.current = newDataCardContent;
    setKey(key + 1);
  }, [workgroupState.externalUserList, checkValues]);
  const handleExandValue = (value: string) => {
    if (!expandValues.includes(value))
      getOrgansTree({
        version: "1.0",
        path: value,
        root: "N",
        onlyDept: "N",
      });
    setExpandValues(
      expandValues.includes(value)
        ? expandValues.filter((item) => item !== value)
        : [...expandValues, value]
    );
  };
  const renderInternalUserList = () => {
    return (
      <Box classes="selectUserModal-tree">
        {treeData && treeData.length > 0 && (
          <Tree
            treeData={{
              columnText:
                window.eco.serviceType === "OCI" ||
                !loginDto?.ecoCommonConfig.companyName
                  ? t("common.internalUser")
                  : loginDto?.ecoCommonConfig.companyName,
              subTree: [...treeData],
              showChildren: true,
              hasChildren: true,
              value: "ae4fc0f5fd8f4142834c1ad4e929a514",
              type: "dept",
            }}
            width="100%"
            isHoverColorGray
            depth={0}
            isOnlyUser
            checkType="plus"
            treeType="eco"
            disableValues={disableValues ?? [myId]}
            checkValues={checkValues.map((item) => item.userId)}
            checkAction={(value: any) =>
              changeCheckValues(
                checkValues.includes(value)
                  ? checkValues.filter((item) => item !== value)
                  : [
                      ...checkValues,
                      {
                        status: 1,
                        userId: value.value,
                        userName: value.columnText,
                        deptName: loginDto.ecoCommonConfig.companyName,
                        userType: 1,
                      },
                    ]
              )
            }
            expandValues={expandValues}
            expandAction={(value: string) => handleExandValue(value)}
            expandSearchValues={["COMPANY"]}
          />
        )}
      </Box>
    );
  };
  const renderExternalUser = (item: Member) => {
    const selected = checkValues
      .map((item1) => item1.userId)
      .includes(item.userId);
    const disabled = disableValues?.includes(item.userId);

    return {
      id: item.userId,
      data: (
        <Box
          alignItems="center"
          height={50}
          classes={classNames("selectUserModal-external--users", {
            selected: selected,
          })}
        >
          <Avatar
            uniqueCode={utilsCommon.getUserColor(item.userType, item.status, item?.userName)}
            name={item.userName ?? item.userId}
            icon={item.userName ? undefined : "user"}
          />
          <Box
            classes="mg ml-8"
            direction="column"
            maxWidth={"calc(100% - 75px)"}
          >
            <Tooltip message={item.userId}>
              <Typography
                ellipsis
                type="body2_rg"
                exactColor={getColor(
                  disabled ? "COLOR_TEXT_INFO" : "COLOR_TEXT_PRIMARY"
                )}
              >
                {utilsCommon.getUserNameIdTag(item.userId, item.userName)}
              </Typography>
            </Tooltip>

            <Typography
              type="caption1_rg"
              exactColor={getColor(
                disabled ? "COLOR_TEXT_INFO" : "COLOR_TEXT_SECONDARY"
              )}
              ellipsis
              classes="mg mt-2"
            >
              {item.deptName}
            </Typography>
          </Box>
          {item.status !== 1 && (
            <Typography
              exactColor={getColor("COLOR_TEXT_ERROR")}
              classes="unregist"
              type="caption1_rg"
              whiteSpace="noWrap"
            >
              {t("common.noRegist")}
            </Typography>
          )}
          <Button
            btnStyle="none"
            type="primary"
            size="sm"
            onClick={() =>
              changeCheckValues([
                ...checkValues,
                {
                  type: "user",
                  status: item.status,
                  userId: item.userId,
                  deptName: item.deptName,
                  userName: item.userName ?? null,
                  userType: 2,
                },
              ])
            }
            classes={classNames("mg ml-auto", {
              "icon-hover--green": !selected,
            })}
            state={disabled ? "disable" : selected ? "noClick" : "default"}
            leadingIcon={
              <Tooltip message={t("common.add")}>
                <Icons
                  variant="line"
                  label="plus"
                  stroke={getColor(
                    disabled
                      ? "COLOR_ICON_INTERACTIVE_PRIMARY_DISABLED"
                      : selected
                      ? "COLOR_ICON_INTERACTIVE_BRAND_DISABLED"
                      : "COLOR_ICON_INTERACTIVE_PRIMARY"
                  )}
                />
              </Tooltip>
            }
          />
        </Box>
      ),
    };
  };
  const renderExternalUserList = () => {
    return (
      <Box classes="selectUserModal-external">
        <InfiniteScrollBox
          data={workgroupListNewCard.current}
          endReached={() => console.log("!")}
          height={"500px"}
          width="100%"
        />
      </Box>
    );
  };
  return (
    <Modal
      open={open}
      onClose={onClose}
      classes={classNames("selectUserModal", classes)}
      title={t("workgroup.selectUser")}
      isHeaderDivider
      isBack
      onBack={onClose}
      isExit={!isClient}
      width="816px"
      bodyMargin={0}
      bodyPadding={0}
      isFooterDivider
      bodyHeight={556}
      footer={
        <Box>
          <Button
            label={t("common.cancel")}
            btnStyle="fill"
            type="secondary"
            onClick={onClose}
          />
          <Button
            label={t("common.apply")}
            btnStyle="fill"
            onClick={() => {
              onClose();
              onClick(checkValues);
            }}
          />
        </Box>
      }
      body={
        <Box height={"100%"}>
          <Box width={472} classes="selectUserModal-left">
            <Tabs
              tabs={[
                {
                  text: t("common.internalUser"),
                  color: "default",
                },
                {
                  text: t("common.externalUser"),
                  color: "default",
                },
              ]}
              classes="mg mt-20"
              type="full"
              selected={tab}
              selectTab={(newTab) => changeTab(newTab)}
              size={"md"}
            />
            {tab === 0 ? renderInternalUserList() : renderExternalUserList()}
          </Box>
          <Box width={341} classes="selectUserModal-right">
            <Box classes="selectUserModal-right--header">
              <Box classes="mg mb-6">
                <Typography type="subtitle2">
                  <Trans
                    i18nKey="common.chosenMember"
                    values={{
                      count: checkValues.length,
                    }}
                    components={{
                      1: (
                        <Typography
                          type="subtitle2"
                          exactColor={getColor("COLOR_TEXT_BRAND")}
                        />
                      ),
                    }}
                  />
                </Typography>
              </Box>
              <Button
                label={t("common.deleteAll")}
                btnStyle="link"
                size="sm"
                classes="mg ml-auto"
                state={checkValues.length > 0 ? "default" : "disable"}
                textColor={getColor("COLOR_TEXT_BRAND")}
                onClick={() => changeCheckValues([])}
              />
            </Box>
            <Box classes="selectUserModal-right--userList">
              {checkValues.map((item) => (
                <Box>
                  <Avatar
                    name={item.columnText || item.userName}
                    uniqueCode={
                      !(item.columnText || item.userName)
                        ? ""
                        : utilsCommon.getUserColor(item.userType, item.status, item.userName)
                    }
                    icon={item.columnText || item.userName ? undefined : "user"}
                  />
                  <Box
                    classes="mg ml-8"
                    direction="column"
                    maxWidth={
                      item.status !== 1
                        ? i18n.language.includes("ko")
                          ? "calc(100% - 125px)"
                          : "calc(100% - 170px)"
                        : "calc(100% - 72px)"
                    }
                  >
                    <Tooltip
                      message={utilsCommon.getUserNameIdTag(
                        item.userId,
                        item.columnText ?? item.userName
                      )}
                    >
                      <Typography type="body2_rg" ellipsis>
                        {utilsCommon.getUserNameIdTag(
                          item.userId,
                          item.columnText ?? item.userName
                        )}
                      </Typography>
                    </Tooltip>
                    <Tooltip
                      message={
                        item.userType === 1
                          ? loginDto?.ecoCommonConfig.companyName
                          : item.deptName
                      }
                    >
                      <Typography
                        type="caption1_rg"
                        exactColor={getColor("COLOR_TEXT_SECONDARY")}
                        classes="mg mt-2"
                        ellipsis
                      >
                        {item.userType === 1
                          ? loginDto?.ecoCommonConfig.companyName
                          : item.deptName}
                      </Typography>
                    </Tooltip>
                  </Box>
                  {item.status !== 1 && item.userType !== 1 && (
                    <Typography
                      exactColor={getColor("COLOR_TEXT_ERROR")}
                      classes="unregist"
                      type="caption1_rg"
                      whiteSpace="noWrap"
                    >
                      {t("common.noRegist")}
                    </Typography>
                  )}
                  <Button
                    btnStyle="icon"
                    classes="mg ml-auto"
                    leadingIcon={<Icons variant="line" label="delete" />}
                    onClick={() =>
                      changeCheckValues(
                        checkValues.filter(
                          (item1) => item1.userId !== item.userId
                        )
                      )
                    }
                  />
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      }
    />
  );
};
export default SelectUserModal;
